$(document).ready(function(){
  window.addEventListener("klaviyoForms", function(e) { 
     console.log(e);
     console.log(e.detail.formId);
        if (e.detail.type == 'submit' && e.detail.formId == 'TShj72') {
         $('.footer__newsletter-text, .right-side-sct').hide();
        $('.newletter-header-cstm').addClass('after_submit_form');
          $('.footer__block.footer__newsletter.footer__block--one-third').css('padding',17);
        }
    });
 $(document).on('click', '.pdp_sizeguid', function() {
        $(".popup").fadeIn(500); 
        $("body").addClass("popup-open"); 
    });
 $(document).on('click', function(e) {
        if (!$(e.target).closest('.popup__content').length && !$(e.target).closest('.pdp_sizeguid').length) {
            // Close the popup
            $(".popup").fadeOut(500); // Hide the popup
            $("body").removeClass("popup-open"); // Remove class from body
        }
    });
   
    $(document).on('click', '.close', function() {
        $(".popup").fadeOut(500); // Hide the popup
        $("body").removeClass("popup-open"); 
    });

  
  // Filter popup close on click outside START
  $(document).on('click', function(event) {
    var $target = $(event.target);
    if (!$target.closest('.size-desktop').length && $('.size-desktop').attr('open') !== undefined) {
        $('.size-desktop').removeAttr('open');
    }
     $(document).on('click', '.mobile-facets__open', function() {
    $(this).parents('.mobile-facets__disclosure').find('.mobile-facets__details.js-filter').addClass('menu-opening').attr('open', '');
  });
});
  // Filter popup close on click outside END
  
    if( $('.logo-animation').length >0){
    $('.logo-animation').slick({
		infinite: true,
		slidesToShow:1,
		slidesToScroll: 1,
		autoplay: true,
        rows: 5,
		arrows: false,
		dots: false,
		fade: false,
		cssEase: 'linear',
		swipeable: false,
		autoplaySpeed: 4000,
		speed: 600,
      adaptiveHeight: true,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					rows: 5,
					slidesToShow: 1,
					slidesToScroll: 1,
					fade: true
				}
			}
		]
	});
  if ($(window).width() > 1024) {
  setTimeout(function(){
			$('.logo-animation .slick-slide').addClass('lowopacity');
		},3400);

		$('.logo-animation').on('afterChange', function(event, slick, currentSlide, nextSlide){
			$('.logo-animation .slick-slide').removeClass('lowopacity');
			setTimeout(function(){
				$('.logo-animation .slick-slide').addClass('lowopacity');
			},3400);
		});
  }
    }
  
// $('.desktop-small-square').each(function(){
//     if($(this).find('.bottom_custom_button').hasClass('custom-bottom-outer-image')){
//         $(this).find('a.btn.btn--tertiary').hide();
//         $(this).find('.bottom_custom_button').show();
//     }else{
//          $(this).find('a.btn.btn--tertiary').show();
//         $(this).find('.bottom_custom_button').hide();
//     }
// });
  
  var  DivLenght = $('.gallery__content-wrapper--bottom-outer-image').length;
 if(DivLenght >= 1){
        $('.gallery.gallery_box').addClass('custom_gallery')
      }else{
   $('.gallery.gallery_box').removeClass('custom_gallery')
      }

//   const myInterval = setInterval(myTimer, 1000);
  
//   function myTimer() {
//  //  var divSeond = $('.desktop-small-square .custom_buttom_image').height();
//  // $('.gallery.custom_gallery .gallery__wrapper.grid-item--desktop-small-square').css('padding-top',divSeond) 
//     //     var divFirst = $('.desktop-large-square .gallery__content-wrapper').height();
//     // var divSeond = $('.desktop-small-square .custom_buttom_image').height();
//     //   var finalHeigjht = divFirst+divSeond+100;
//     //   $('.gallery.custom_gallery').css('height' , finalHeigjht);
//  }

// function myStopFunction() {
//   clearInterval(myInterval);
// }

  
  $(document).on('click','.product-form__submit',function(){
var clrInterval = setInterval(function() {
  var chkcartCount = $('.cart-item-count').html();
  if( chkcartCount !=''){
    $('#cart-svg-count').addClass('cart-show');
    clearInterval(myInterval);
  }
},500);

  });   

 
  

 $('.cstm_united-states').children('.cstm_US').text('USD($)');
  $('.cstm_united-kingdom').children('.cstm_GB').text('GBP(£)');
  $('.cstm_sweden').children('.cstm_SE').text('EUR(€)');

    var cstmsweden = $('.crossborder__toggle').children('span:first').text(); 

var Chekcountry = $.trim(cstmsweden);
  
  if( Chekcountry =='Sweden (EUR €)'){
    $('.crossborder__toggle').children('span:first').text('EUR(€)');
    $('.crossborder__toggle').css('display','block');
  } else if(Chekcountry =='United States (USD $)'){
    $('.crossborder__toggle').children('span:first').text('USD($)');
    $('.crossborder__toggle').css('display','block');
  }
  else if(Chekcountry =='United Kingdom (GBP £)'){
    $('.crossborder__toggle').children('span:first').text('GBP(£)');
    $('.crossborder__toggle').css('display','block');
  }else{
    $('.crossborder__toggle').children('span:first').text('USD($)');
    $('.crossborder__toggle').css('display','block');
  }
  

  $(document).on('click','.promo-bar__container',function(){
    $('.disclosure').children('#currency-list').removeClass('disclosure-list--visible');
    $('button.crossborder__toggle.crossborder__toggle--header').attr('aria-expanded','false');
  });


$(document).on('click', function (event) {
  if (!$(event.target).closest('.disclosure').length) {
    // ... clicked on the 'body', but not inside of #menutop
    $('.disclosure').children('#currency-list').removeClass('disclosure-list--visible');
    $('button.crossborder__toggle.crossborder__toggle--header').attr('aria-expanded','false');
  }
});
  
  $(document).on('click','.header__nav',function(){
 
      $('.disclosure').children('#currency-list').removeClass('disclosure-list--visible');
    $('button.crossborder__toggle.crossborder__toggle--header').attr('aria-expanded','false');
    

  });
  
      $(document).on('click','#PageContainer',function(){
    $('.disclosure').children('#currency-list').removeClass('disclosure-list--visible');
    $('button.crossborder__toggle.crossborder__toggle--header').attr('aria-expanded','false');
  });    
$(document).on('click','.cstm_curr button.crossborder__toggle.crossborder__toggle--header',function(){ 
   $(this).attr('aria-expanded','true');
    $(this).parent('.disclosure').children('#currency-list').toggleClass('disclosure-list--visible');
});
$(document).on('click','.cstm_curr li.crossborder__disclosure-item',function(){
  var cstm_currency = $(this).children('a').attr('data-value');
  $('#CurrencySelector').val(cstm_currency);
  $('#localization_form').submit();
});

  
  $(document).on('click','.mobile__nav-crossborder button.crossborder__toggle.crossborder__toggle--header',function(){ 
   $(this).attr('aria-expanded','true');
    $(this).parent('.disclosure').children('#currency-list').toggleClass('disclosure-list--visible');
});
$(document).on('click','.mobile__nav-crossborder li.crossborder__disclosure-item',function(){
  var cstm_currency = $(this).children('a').attr('data-value');
  $('#CurrencySelector').val(cstm_currency);
  $('#localization_form').submit();
});
 // new pdp js start
$(".dropdown-button").click(function() {
$(".dropdown-menu").toggle();
});
$(".dropdown-menu li").click(function() {
var selectedText = $(this).text();
// $(".dropdown-button").text(selectedText);
$(".dropdown-menu").hide();
});
//  $(document).click(function (e) {
//  e.stopPropagation();
// var container = $(".select-dropdown");
//  if (container.has(e.target).length === 0) {
// $('.dropdown-menu').hide();
// }
// }) 
$(".dropdown-button").click(function() {
if ($(this).hasClass("intro")) {
$(this).removeClass("intro");
} else {
$(this).addClass("intro");
}
});
$(document).click(function (e) {
  e.stopPropagation(); // Prevent the click event from propagating to the document
  var container = $(".select-dropdown");
  if (container.has(e.target).length === 0) {
    $('.dropdown-menu').hide();
    $('.dropdown-button').removeClass("intro"); // Add quotes around the selector
  }
});
  // slider js 
  $('.bunmain').flickity({
  
  cellAlign: 'left',
  contain: true,
   groupCells: 2,
});
 var selectorimage = $(".metafield-image").attr('src');
$('#imgconatinerselector').prepend('<img id="theImg" src="' + selectorimage + '" />');
$('.product .product__meta .description h3, .product .product__meta .description span').css({
      
      'font-family': 'Gill-Sans!important'
    });
//   $(' p.product-loop_title a').each(function () {
//   var get_val = $(this).text();
// // //    // console.log(get_val);
//     var get_split_them = get_val.split('-')[0];
//      // console.log(get_split_them);
//    var get_second_val = get_val.split('-')[1];
//     // console.log(get_second_val);
//    $(this).text(get_split_them);
//       var get_last_html = $("<span class='custom_last_part_html'>"+ get_second_val +"</span>");
//     $(this).append(get_last_html);
//    });
 
//new pdp js end  
  
  
});
	// $(window).on("load resize",function(e){
 //      var annouc_height =  jQuery('div#shopify-section-announcement-bar').height();
 //      var header_height =  jQuery('div#shopify-section-header').height();
 //      var total_height = annouc_height + header_height ;
 //      jQuery( '.slideshow__wrapper  .flickity-viewport' ).css({ 'height': 'calc(100vh - ' + total_height+ 'px)' });
 //      });


// (function() {
//   function moveUpsellWidget() {
//     const upsellWidget = document.querySelector('.lazysection.wrapper.lazyloaded');
//     const cartItemsSection = document.querySelector('#main-cart-items');
//     const cartWrapper = document.querySelector('.cart__wrapper');

//     // Mobile only
//     if (window.innerWidth <= 768 && upsellWidget && cartItemsSection && cartWrapper) {
//       // Avoid double move
//       if (!upsellWidget.classList.contains('moved')) {
//         // Move upsell widget right after the cart items section
//         cartWrapper.insertBefore(upsellWidget, cartItemsSection.nextSibling);

//         // Mark as moved to prevent double move
//         upsellWidget.classList.add('moved');
    
//         clearInterval(waitForUpsell);
//       }
//     }
//   }

//   // Keep checking until the upsell widget and cart items appear
//   const waitForUpsell = setInterval(moveUpsellWidget, 500);
// })();







